<template>
  <div
    class="post border-bottom"
    itemscope=""
    itemtype="http://schema.org/BlogPosting"
    itemprop="blogPost"
  >
    <header>
      <h2 itemprop="name headline">
        <a
          :href="'/blog/post/' + blogPost.slug"
          rel="canonical"
          itemprop="url"
          >{{ blogPost.title }}</a
        >
      </h2>

      <time :datetime="blogPost.pubDate" itemprop="datePublished">{{
        blogPost.pubDate | formatDate
      }}</time>
    </header>
    <article
      class="text-justify post__content"
      itemprop="articleBody mainEntityOfPage "
      v-html="blogPost.excerpt"
    />
  </div>
</template>

<script>
export default {
  name: "BlogPost",
  props: {
    blogPost: Object,
  },
};
</script>

<style>
.post__content {
  text-indent: 1em;
}

.post {
  padding: 0.5em;
}
</style>